module.exports = __webpack_public_path__ + "static/img/areaA-21.8bdfd67.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-21.png
// module id = 933
// module chunks = 1